import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./SidebarRight.css";
import { hideSidebarRight } from "../../slices/mapSlice";
import { getAuthToken, PIXEL_SERVER } from "../../common/utils/apiService";
import { clearSelectedFeatureIds, clearSimilarResults, setSelectedFeatureIds } from "../../slices/searchSlice";
import { Close } from "../../assets/images/svgs/Icons";
import CompareModal from "./CompareModal";
import PreviewThumb from "./PreviewThumb";
import { Loader } from "rsuite";

const SidebarRight = () => {

  const dispatch = useDispatch();

  const isSidebarOpen = useSelector(state => state.map.isSidebarOpen);
  const similarResults = useSelector(state => state.search.similarResults);
  const selectedSimilarImageIds = useSelector((state) => state.search.selectedSimilarImageIds);
  const loadingSimilarResults = useSelector((state) => state.search.loadingSimilarResults);
  const [showCompare, setShowCompare] = useState(false);



  const getPreviewUrl = (feature) => {
    const collectionId = feature.collection;
    const itemId = feature.id;

    return `${PIXEL_SERVER}/px/preview?collection=${collectionId}&item=${itemId}&auth_token=${getAuthToken(true)}&resize=256&filetype=png`;
  };

  const handleSelectFeature = (feature, event) => {
    dispatch(
      setSelectedFeatureIds((prev => {
        const isShift = event.shiftKey;
        const isAlreadySelected = prev.includes(feature.id);

        if (!isShift) return [feature.id];

        if (isAlreadySelected) {
          return prev.filter(id => id !== feature.id);
        }

        if (prev.length >= 2) return prev;

        return [...prev, feature.id];
      })(selectedSimilarImageIds))
    );
  };

  const selectedFeatures = selectedSimilarImageIds
    .map(id => similarResults?.features?.find(f => f.id === id))
    .filter(Boolean);

  const closeTopBarItem = () => {
    dispatch(hideSidebarRight());
    dispatch(clearSimilarResults());
    dispatch(clearSelectedFeatureIds());
    // props.setIsSelectedTopBarItem({ Collection: false, Archive: false });
  };


  return (
    <>
      {isSidebarOpen && (
        <div className="udpSidebarRight">
          <div className="udpSidebarRightHeader">
            <div className="udpSidebarRightHeaderTitle">
              Similar Results
            </div>
            <button className="icon-button" onClick={closeTopBarItem}>
              <Close />
            </button>
          </div>

          <div className="udpSidebarRightBody">
            {loadingSimilarResults ? (
              <>
                <Loader inverse center content="loading, please wait..." />
              </>
            ) : similarResults?.features?.length > 0 ? (
              similarResults.features.map((feature) => {
                const isSelected = selectedSimilarImageIds.includes(feature.id);

                return (
                  <div
                    key={feature.id}
                    className={`udpPreviewCard ${isSelected ? "selected" : ""}`}
                    onClick={(e) => handleSelectFeature(feature, e)}
                  >
                    <div className="udpPreviewThumb">
                      <PreviewThumb src={getPreviewUrl(feature)} />
                    </div>

                    <div className="udpPreviewMeta">
                      <div className="udpMetaRow">
                        <span className="udpMetaLabel">
                          Cloud cover:{" "}
                          {feature.properties?.["eo:cloud_cover"] != null
                            ? `${feature.properties["eo:cloud_cover"]}%`
                            : "N/A"}
                        </span>
                        <span className="udpMetaValue">
                          {feature.properties?.datetime
                            ? new Date(feature.properties.datetime).toLocaleString()
                            : "—"}
                        </span>
                      </div>
                    </div>

                    <div className="udpPreviewActions">⋮</div>
                  </div>
                );
              })
            ) : (
              <div className="emptyState">No similar results found</div>
            )}
          </div>
          <div className="udpSidebarRightFooter">
            <button
              className="compareButton"
              disabled={selectedSimilarImageIds.length !== 2}
              onClick={() => {
                // future: open compare modal / route
                setShowCompare(true);
              }}
            >
              Compare Images
            </button>
          </div>
        </div>
      )}
      {showCompare && selectedFeatures.length === 2 && (
        <CompareModal
          leftImage={getPreviewUrl(selectedFeatures[0])}
          rightImage={getPreviewUrl(selectedFeatures[1])}
          leftDate={selectedFeatures[0]?.properties?.datetime}
          rightDate={selectedFeatures[1]?.properties?.datetime}
          onClose={() => setShowCompare(false)}
        />
      )}
    </>
  );
};

export default SidebarRight;
